import {
  Box,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { Close, ThumbDownAlt, ThumbUpAlt, Update } from "@material-ui/icons";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  Datagrid,
  ExportButton,
  FormDataConsumer,
  FunctionField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import { DetailButton } from "../../../Components/DetailButton";
import { ConfirmButton } from "../../../Components/ConfirmButton";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { useAppDataProvider } from "../../../dataprovider";
import { TabbedDatagridProps } from "../../../Models/TabbedDataGridProps";
import { Form } from "react-final-form";
import { EnumField } from "../../../../src/Components/EnumField";
import { ReliabilityAfterPoolVendorTypeChoices } from "../../../Enums/ReliabilityAfterPoolVendorType";
import { SourceReliabilityThyPrematureFailure } from "./Constants";
import { ExcelExport } from "../../../../src/Helper/ExportExcel";
import {
  ReliabilityPrematureFailureChoices,
  ReliabilityPrematureFailureStatus,
} from "../../../../src/Enums/ReliabilityPrematureFailureStatus";
import {
  ReliabilityNotPrematureFailureReasonType,
  ReliabilityPrematureFailureReasonChoices,
  ReliabilityPrematureFailureReasonType,
  ReliabilityPrematureFailureRejectReasonType,
} from "../../../../src/Enums/ReliabilityPrematureFailureReasonType";
import { ReliabilityThyPrematureFailureUpdateModel } from "../Models/ReliabilityThyPrematureFailureModel";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { ReliabilityBeforePoolVendorTypeChoices } from "../../../../src/Enums/ReliabilityBeforePoolVendorType";
import { formatDate } from "../../../../src/Helper/MomentHelper";

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh(); 

  const AcceptThyPrematureFailureButton = props => {
    const acceptButtonClick = record => e => {
      let reliabilityThyPrematureFailure: ReliabilityThyPrematureFailureUpdateModel =
        new ReliabilityThyPrematureFailureUpdateModel();
      reliabilityThyPrematureFailure.Id = record?.id;
      reliabilityThyPrematureFailure.Batch = record?.batch;
      reliabilityThyPrematureFailure.ReportId = record?.reportId;
      reliabilityThyPrematureFailure.BeforeRemovalOrderType = record?.beforeRemovalOrderType;
      reliabilityThyPrematureFailure.BeforeRemovalOrderNumber = record?.beforeRemovalOrderNumber;
      reliabilityThyPrematureFailure.BeforeRemovalOrderStatus = record?.beforeRemovalOrderStatus;
      reliabilityThyPrematureFailure.BeforeRemovalVendorType = record?.beforeRemovalVendorType;
      reliabilityThyPrematureFailure.BeforeRemovalVendor = record?.beforeRemovalVendor;
      reliabilityThyPrematureFailure.BeforeRemovalCondition = record?.beforeRemovalCondition;
      reliabilityThyPrematureFailure.AfterRemovalOrderType = record?.afterRemovalOrderType;
      reliabilityThyPrematureFailure.AfterRemovalOrderNumber = record?.afterRemovalOrderNumber;
      reliabilityThyPrematureFailure.AfterRemovalOrderStatus = record?.afterRemovalOrderStatus;
      reliabilityThyPrematureFailure.AfterRemovalVendorType = record?.afterRemovalVendorType;
      reliabilityThyPrematureFailure.AfterRemovalVendor = record?.afterRemovalVendor;
      reliabilityThyPrematureFailure.AfterRemovalCondition = record?.afterRemovalCondition;
      reliabilityThyPrematureFailure.AcReg = record?.acReg;
      reliabilityThyPrematureFailure.AcType = record?.acType;
      reliabilityThyPrematureFailure.FleetType = record?.fleetType;
      reliabilityThyPrematureFailure.AcRemoveDate = record?.acRemoveDate;
      reliabilityThyPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.Confirmed;

      dataProvider
        .putReliabilityThyPrematureFailure(reliabilityThyPrematureFailure)
        .then(result => {
          notify(`Reliability Thy Premature Failure Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: "#12824C" }}
        size="medium"
        click={acceptButtonClick(props?.record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept THY Premature Failure">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RejectThyPrematureFailureButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const RejectReliabilityThyPrematureFailureButtonClick = props => e => {
      let reliabilityThyPrematureFailure: ReliabilityThyPrematureFailureUpdateModel =
        new ReliabilityThyPrematureFailureUpdateModel();
      reliabilityThyPrematureFailure.Id = props?.record?.id;
      reliabilityThyPrematureFailure.Batch = props?.record?.batch;
      reliabilityThyPrematureFailure.ReportId = props?.record?.reportId;
      reliabilityThyPrematureFailure.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityThyPrematureFailure.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityThyPrematureFailure.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityThyPrematureFailure.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityThyPrematureFailure.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityThyPrematureFailure.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityThyPrematureFailure.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityThyPrematureFailure.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityThyPrematureFailure.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityThyPrematureFailure.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityThyPrematureFailure.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityThyPrematureFailure.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityThyPrematureFailure.AcReg = props.record?.acReg;
      reliabilityThyPrematureFailure.AcType = props.record?.acType;
      reliabilityThyPrematureFailure.FleetType = props.record?.fleetType;
      reliabilityThyPrematureFailure.AcRemoveDate = props.record?.acRemoveDate;
      reliabilityThyPrematureFailure.Reason = e.reason;
      reliabilityThyPrematureFailure.OtherReason = e.otherReason;
      reliabilityThyPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.Rejected;

      dataProvider
        .putReliabilityThyPrematureFailure(reliabilityThyPrematureFailure)
        .then(result => {
          notify(`Reliability THY Premature Failure Updated`, "success", false, true);
          setOpen(false);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40 }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Reject Premature Failure">
            <ThumbDownAlt />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reject Premature Failure</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={RejectReliabilityThyPrematureFailureButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        choices={ReliabilityPrematureFailureRejectReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />
                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityPrematureFailureReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        label={"Reject Premature Failure"}
                        size="large"
                        variant="contained"
                        onClick={handleSubmit}
                      >
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const NotThyPrematureFailureButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const ReliabilityNotThyPrematureFailureButtonClick = props => e => {
      let reliabilityThyPrematureFailure: ReliabilityThyPrematureFailureUpdateModel =
        new ReliabilityThyPrematureFailureUpdateModel();
      reliabilityThyPrematureFailure.Id = props?.record?.id;
      reliabilityThyPrematureFailure.Batch = props?.record?.batch;
      reliabilityThyPrematureFailure.ReportId = props?.record?.reportId;
      reliabilityThyPrematureFailure.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityThyPrematureFailure.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityThyPrematureFailure.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityThyPrematureFailure.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityThyPrematureFailure.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityThyPrematureFailure.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityThyPrematureFailure.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityThyPrematureFailure.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityThyPrematureFailure.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityThyPrematureFailure.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityThyPrematureFailure.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityThyPrematureFailure.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityThyPrematureFailure.AcReg = props.record?.acReg;
      reliabilityThyPrematureFailure.AcType = props.record?.acType;
      reliabilityThyPrematureFailure.FleetType = props.record?.fleetType;
      reliabilityThyPrematureFailure.AcRemoveDate = props.record?.acRemoveDate;
      reliabilityThyPrematureFailure.Reason = e.reason;
      reliabilityThyPrematureFailure.OtherReason = e.otherReason;
      reliabilityThyPrematureFailure.PrematureFailureStatus = ReliabilityPrematureFailureStatus.NotPrematureFailure;

      dataProvider
        .putReliabilityThyPrematureFailure(reliabilityThyPrematureFailure)
        .then(result => {
          notify(`Reliability THY Premature Failure Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40, color: "red" }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Not Premature Failure">
            <Close />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Not Premature Failure</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={ReliabilityNotThyPrematureFailureButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Not Premature Failure Reason"
                        choices={ReliabilityNotPrematureFailureReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />

                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityPrematureFailureReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Not Premature Failure"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={SourceReliabilityThyPrematureFailure} />;
  };

  const OptButtonGroup = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailsButton record={record} />
          <>
            <AcceptThyPrematureFailureButton record={record} />
            <RejectThyPrematureFailureButton record={record} />
            <NotThyPrematureFailureButton record={record} />
          </>
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      <Datagrid optimized basePath={SourceReliabilityThyPrematureFailure}>
        <OptButtonGroup record={props} />
        <TextField source="batch" label="Batch" />
        <TextField source="goodsRcvdBatch" label="Goods Received Batch" />
        <TextField source="acReg" label="Ac Reg" />
        <TextField source="pn" label="Pn" />
        <TextField source="sn" label="Sn" />
        <TextField source="pnDescription" label="Pn Description" />
        <FunctionField
          label="Created Date"
          sortBy="createdDate"
          render={(record: any) => {
            return record.createdDate === null ? null : formatDate(record.createdDate);
          }}
        />

        <TextField source="beforeRemovalVendorType" label="Before Removal Vendor Type" />
        <TextField source="afterRemovalVendorType" label="After Removal Vendor Type" />
        <EnumField
          label={"Premature Failure Status"}
          enumName={"ReliabilityPrematureFailureStatus"}
          source={"prematureFailureStatus"}
        />
        <EnumField label={"Reason"} enumName={"ReliabilityPrematureFailureReasonType"} source={"reason"} />
      </Datagrid>
    </Fragment>
  );
};

const ThyPrematureFailureList = props => {
  const ListActions = props => {
    return (
      <TopToolbar {...props}>
        <ExportButton
          resource={props.resource}
          sort={props.currentSort}
          filterValues={props.filterValues}
          maxResults={10000}
        />
      </TopToolbar>
    );
  };

  const exporter = records => {
    const data = records.map(record => {
      const mappedRecord = {
        //...record,
        Batch: record.batch,
        "Goods Received Batch": record.goodsRcvdBatch,
        "Ac Reg": record.acReg,
        "Ac Remove Date": record.acRemoveDate,
        Pn: record.pn,
        Sn: record.sn,
        Chapter: record.chapter,
        "Pn Description": record.pnDescription,
        "Premature Failure Status": ReliabilityPrematureFailureChoices.find(
          x => x.value === record.prematureFailureStatus
        )?.key,
        Reason: ReliabilityPrematureFailureReasonChoices.find(x => x.value === record.reason)?.key,
        "After Removal Order Type": record.afterRemovalOrderType,
        "After Removal Order Number": record.afterRemovalOrderNumber,
        "After Removal Order Status": record.afterRemovalOrderStatus,
        "After Removal Vendor Type": record.afterRemovalVendorType,
        "After Removal Vendor": record.afterRemovalVendor,
        "After Removal Condition": record.afterRemovalCondition,
        "Before Removal Order Type": record.beforeRemovalOrderType,
        "Before Removal Order Number": record.beforeRemovalOrderNumber,
        "Before Removal Order Status": record.beforeRemovalOrderStatus,
        "Before Removal Vendor Type": record.beforeRemovalVendorType,
        "Before Removal Vendor": record.beforeRemovalVendor,
        "Before Removal Condition": record.beforeRemovalCondition,
        "Sub Category": record.subCategory,
        "Reliability Report Created Date": record.reliabilityReportCreatedDate,
      };
      return mappedRecord;
    });

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "THY Premature Failure List");
  };

  const prematureFailureChoices = [{ key: "ALL" }, ...ReliabilityPrematureFailureChoices];

  const filters = [
    <TextInput label="Batch" source="batch__eq" alwaysOn />,
    <TextInput label="Ac Reg" source="acReg__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="Before Removal Vendor Type"
      source="beforeRemovalVendorType__eq"
      choices={ReliabilityBeforePoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="After Removal Vendor Type"
      source="afterRemovalVendorType__eq"
      choices={ReliabilityAfterPoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="Premature Failure Status"
      source="prematureFailureStatus__eq"
      choices={prematureFailureChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <PoolList
          {...props}
          hasCreate={false}
          exporter={exporter}
          actions={<ListActions />}
          bulkActionButtons={false}
          resource={SourceReliabilityThyPrematureFailure}
          title={"THY Premature Failure List"}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={filters}
          filter={props?.filterParams}
        >
          <TabbedDatagrid />
        </PoolList>
      </Grid>
    </Grid>
  );
};

export default ThyPrematureFailureList;
